angular.module("Main").factory("UrlCleanerService", [function () {

    return {
        getCleanUrl: getCleanUrl,
    }

    function getCleanUrl(url) {

            try {
                const urlObj = new URL(url);
                const params = new URLSearchParams(urlObj.search);

                let unserPath = "";
                let unsereParams = new URLSearchParams();

                for (const [k, value] of params.entries()) {
                    const hashMatch = value.match(/(%23|#)(.+)$/);
                    if (hashMatch) {
                        const encString = decodeURIComponent(hashMatch[2]);
                        if (encString.startsWith("!")) {
                            const angularString = encString.substring(1);
                            const [path, queryString] = angularString.split("?");
                            unserPath = path;
                            if (queryString) {
                                unsereParams = new URLSearchParams(queryString);
                            }
                        }
                        break;
                    }
                }

                const unsereUrl = new URL(urlObj.origin + "/booking/");

                let bangFragment = "!" + unserPath;
                if (unsereParams.toString()) {
                    bangFragment += "?" + unsereParams.toString();
                }

                unsereUrl.hash = bangFragment;

                // return unsereUrl.toString().replace(urlObj.origin, "");
                return {
                    path: unserPath,
                    search: unsereParams.toString()
                }


            } catch (e) {
                console.error("Fehler beim Säubern der URL:", e);
                return null;
            }

    }

}]);